import DesktopWindow from './views/DesktopWindow';

function App() {

  return (
    <div>
      <DesktopWindow />
    </div>
  );
}

export default App;
